// Service for the Attendance Dashboard "Mi equipo" filters panel.
// GET /attendance/my-team/filters — sections, companies and employees catalogs.
// GET /attendance/my-team/filters/employees?companyIds=1,2,3 — employees scoped to
// the selected companies (companyIds omitted/[] => "Todos").

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetMyTeamFiltersOut,
  LC_GetMyTeamEmployeesListOut,
  GetMyTeamEmployeesParams,
  MyTeamFilters,
  MyTeamEmployee,
} from '../types/myTeamFilters.types';
import { mapMyTeamFilters, mapMyTeamEmployeesList } from '../mappers/myTeamFilters.mapper';


export class MyTeamFiltersService {
  async getFilters(signal?: AbortSignal): Promise<ApiResponse<MyTeamFilters>> {
    const response = await apiClient.get<LC_GetMyTeamFiltersOut>(
      API_CONFIG.ENDPOINTS.ATTENDANCE_MY_TEAM_FILTERS,
      { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamFilters(response.data) };
  }

  async getEmployees(
    params?: GetMyTeamEmployeesParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamEmployee[]>> {
    const query = buildQueryString({ companyIds: params?.companyIds?.map(String) });
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE_MY_TEAM_FILTERS_EMPLOYEES}${query}`;
    const response = await apiClient.get<LC_GetMyTeamEmployeesListOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamEmployeesList(response.data) };
  }
}

export const myTeamFiltersService = new MyTeamFiltersService();
